module.exports = __webpack_public_path__ + "static/media/wgs2.png.6afd50aa.jpg";